import React, { useRef, useEffect, useCallback } from 'react';


export const PreContentAd = ({ type, onAdComplete }) => {
    const preContentContainerDiv = useRef(null);


    const getBoltCallbacks = useCallback(() => {
        window.Bolt.on('precontent_ad_video', window.Bolt.BOLT_AD_REQUEST_START, () => {
        console.info('Precontent Ad Requested');

        });
    
        window.Bolt.on('precontent_ad_video', window.Bolt.BOLT_AD_STARTED, () => {
        console.info('Precontent Ad Started');
        });
    
        window.Bolt.on('precontent_ad_video', window.Bolt.BOLT_AD_COMPLETE, () => {
        console.info('Precontent Ad Completed');
            onAdComplete();
        });
    
        window.Bolt.on('precontent_ad_video', window.Bolt.BOLT_AD_ERROR, () => {
        console.error('Precontent Ad Error');
            onAdComplete();
        });
    }, []);


    // Function to add ad the pre-content-ad unit
    const addUnit = () => {
        window.ramp.que.push(() => {
            window.ramp.addUnits([{ type }])
                .then(() => { window.ramp.onPlayerReady = getBoltCallbacks; })
                .catch(e => console.warn('Error adding pre-content-ad unit:', e))
                .finally(() => { window.ramp.displayUnits(); });
        });
    };

    // Cleanup function to remove ad units and precontent ad callback
    const cleanUp = () => {
        if (window.ramp?.destroyUnits) {
            window.ramp.destroyUnits([type]);
            delete window.ramp.onPlayerReady;
        }
    };


    useEffect(() => {
        addUnit();
        return () => cleanUp();
    }, []);


    return (
      <div
        ref={preContentContainerDiv}
        style={{
            transition: 'all 820ms cubic-bezier(0.230, 1.000, 0.320, 1.000)',
            width: '100%',
            height: '500px',
            position: 'relative',
          }}
      >
        <div id="pw_precontent_video_container" />
      </div>
    );
};
